import { Button, Fade, Tooltip } from "@mui/material";
import { IButtons } from "./Types/Buttons.types";
import { getButtonSx, mergeSx } from "./buttonStyles";

export const ButtonTertiaryIcon = ({
  size = "sm",
  sx,
  sxButton,
  iconOnly,
  tooltip,
  children,
  ...props
}: IButtons) => {
  const button = (
    <Button
      disableRipple
      {...props}
      sx={mergeSx(
        (theme) => getButtonSx(theme, "tertiaryIcon", size),
        sx,
        sxButton,
      )}
    >
      {iconOnly ?? children}
    </Button>
  );

  return tooltip ? (
    <Tooltip title={tooltip} TransitionComponent={Fade}>
      {button}
    </Tooltip>
  ) : (
    button
  );
};
